import { useRepoReplicache } from '../../hooks-data/use-repo-replicache'
import { branchMutators } from '@basehub/data/replicache/mutators/repo-space/branch/mutators'
import { useReplicacheQueryV2 } from '../../hooks-data/use-replicache-query'
import { useQuery } from '@tanstack/react-query'
import { useActiveSpaceId } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/repo-store'
import { invariant } from '@epic-web/invariant'
import { useDashboardSlugs } from '~/hooks/use-dashboard-slugs'
import { branchSchema } from '@basehub/data/replicache/index'

export const useDefaultBranch = () => {
  const { isLoading: isLoadingSlugs } = useDashboardSlugs()
  const { isLoading: isLoadingReplicache, data: repoReplicacheData } =
    useRepoReplicache()
  const spaceId = useActiveSpaceId() ?? repoReplicacheData?.spaceId
  const replicache = repoReplicacheData?.replicache
  const replicacheQueryEnabled = !isLoadingReplicache && Boolean(replicache)
  const fallbackQueryEnabled =
    !isLoadingSlugs &&
    !isLoadingReplicache &&
    !replicacheQueryEnabled &&
    !!spaceId

  const query = useReplicacheQueryV2({
    key: ['defaultBranch', spaceId, 'replicache'],
    replicache,
    fetcher: async (tx) => {
      const branches = await branchMutators.listBranches(tx)
      const defaultBranch = branches.find((b) => b.isDefault)
      if (!defaultBranch) return null
      return defaultBranch
    },
    enabled: replicacheQueryEnabled,
  })

  const fallback = useQuery(
    ['defaultBranch', spaceId, 'fallback'],
    async () => {
      invariant(spaceId, 'spaceId is undefined, this should not happen.')
      const defaultBranchResponse = await fetch(
        `/api/ad-hoc/branch-or-commit?spaceId=${encodeURIComponent(spaceId)}`
      ).then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch branches')
        }

        return res.json()
      })
      return branchSchema.parse(defaultBranchResponse)
    },
    {
      staleTime: Infinity,
      enabled: fallbackQueryEnabled,
    }
  )

  if (!replicache) {
    return fallback
  }

  return query
}
